module.exports = __webpack_public_path__ + "static/img/color-cartridge_256.1de9d7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color-cartridge_256.png
// module id = 3utI
// module chunks = 0